<template>
  <div class="page-index">
    <NavComponent :indexPath="indexPath"></NavComponent>
    <div>
      <div class="banner">
        <ProgressiveImage
          no-fade
          img-class="img"
          :src="currentBanner.jpg"
          :avif="heroAvifSrcset"
          :webp="heroWebpSrcset"
          alt="Yous Link Banner"
          loading="eager"
          fetchpriority="high"
          :width="currentBanner.width"
          :height="currentBanner.height"
          :aspect-ratio="currentBanner.width + '/' + currentBanner.height"
          sizes="(max-width: 1024px) 100vw, 1440px"
        />
      </div>

      <div class="search">
        <div class="tab">
          <div :class="tabActive == 1 ? 'item tab-active' : 'item'" @click="changeStage()">
            For New Home
          </div>
          <div :class="tabActive == 2 ? 'item tab-active' : 'item'" @click="changeStage()">
            To Resale
          </div>
        </div>
        <div v-if="tabActive == 1" class="input-item">
          <el-input class="input" v-model="search.keyword" placeholder="Search"></el-input>
          <ProgressiveImage :src="search_icon" img-class="search-icon" alt="Search" />
          <div class="select-item">
            <el-select v-model="search.min_price" placeholder="Min price">
              <el-option
                v-for="item in price"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
          <div class="select-item">
            <el-select v-model="search.max_price" placeholder="Max price">
              <el-option
                v-for="item in price"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
          <div class="select-item">
            <el-select v-model="search.property_type" placeholder="Property type">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
          <div class="select-item">
            <el-select v-model="search.min_bedroom" placeholder="Bedrooms">
              <el-option v-for="item in setting.bedroom" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
        </div>

        <div v-if="tabActive == 2" class="input-item rent">
          <el-input class="input" v-model="search.keyword" placeholder="Search"></el-input>
          <ProgressiveImage :src="search_icon" img-class="search-icon" alt="Search" />
          <div class="select-item">
            <el-select v-model="search.min_price" placeholder="Min price">
              <el-option
                v-for="item in price"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
          <div class="select-item">
            <el-select v-model="search.max_price" placeholder="Max price">
              <el-option
                v-for="item in price"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
          <div class="select-item">
            <el-select v-model="search.property_type" placeholder="Property type">
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <ProgressiveImage :src="row_down" img-class="select-icon" alt="Dropdown arrow" />
          </div>
        </div>
        <el-button class="button" @click="pushSearch()">Search</el-button>
      </div>
    </div>

    <main class="content-container">
      <!-- 新增部分 new house -->
      <div class="title">
        <h1 class="name">FEATURED NEW BUILD</h1>
        <div class="describe">
          <div class="des-text">Online Viewing、 Premium Location、High Yield</div>
          <div @click="goSaleList('1')" class="des-more">MORE</div>
        </div>
      </div>
      <div class="burling-box new-house">
        <CompHouseCard
          v-for="(item, index) in newHouse"
          :key="'new-' + index"
          :item="item"
          :loading="newHouseLoading"
          :showFrom="true"
          priority="high"
          @click="newHouseLoading ? null : goHouseDetail(item.id, '1')"
        />
        <div class="kong" v-if="newHouse.length == 2 && !newHouseLoading"></div>
      </div>
      <!-- 预售部分 -->
      <div class="title">
        <div class="name">FEATURED PROPERTIES FOR SALE</div>
        <div class="describe">
          <div class="des-text">Online Viewing、 Premium Location、High Yield</div>
          <div @click="goSaleList('2')" class="des-more">MORE</div>
        </div>
      </div>
      <div class="burling-box new-house">
        <CompHouseCard
          v-for="(item, index) in saleHouse"
          :key="'sale-' + index"
          :item="item"
          :loading="saleHouseLoading"
          :showFrom="false"
          @click="saleHouseLoading ? null : goHouseDetail(item.id, '2')"
        />
        <div class="kong" v-if="saleHouse.length == 2 && !saleHouseLoading"></div>
      </div>

      <div class="title">
        <div class="name">PROPERTY MANAGEMENT</div>
        <div class="describe">
          <div class="des-text">One Stop Management Service Around You</div>
          <div class="des-more" @click="goManagementPage()">MORE</div>
        </div>
      </div>
      <div class="burling-box new-house">
        <CompHouseCard
          v-for="(item, index) in managementList"
          :key="'management-' + index"
          :item="item"
          :loading="managementLoading"
          mode="management"
          @click="managementLoading ? null : goManagementDetail(item.id)"
        />
        <div class="kong" v-if="managementList.length == 2 && !managementLoading"></div>
      </div>
      <!-- <ManagementComponent></ManagementComponent> -->

      <!-- <div class="title">
        <div class="name">PROPERTY  TO  RENT</div>
        <div class="describe">
          <div class="city-list"><div class="city-name" v-for="(item,index) in rent"  :class="[cityIndex2 == index ? 'active-city' : '','city-name']" :key="index" @click="switchTab2(index)">{{item.cityName}}</div></div>
          <div class="des-more">LEARN MORE</div>
        </div>
        <div class="city-item">
          <div class="city-img" v-for="(item,index) in rentList" :key="index">
            <el-image class="image"  :src="item.image">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="house-name">{{item.architecture}}</div>
          </div>
          <div class="city-img" v-if="rentList.length == 2"></div>
        </div>
      </div> -->
    </main>
    <div class="other-box">
      <div class="content-container">
        <div class="title">
          <div class="name">OTHER SERVICES</div>
        </div>
        <div
          class="other-item"
          @click="
            () => {
              this.$router.push('/otherService');
            }
          "
        >
          <div
            class="item hover:shadow transition-shadow duration-300"
            v-for="(item, index) in other"
            :key="index"
          >
            <ProgressiveImage
              img-class="other-item-img"
              container-class="shrink-0"
              :src="item.img"
              :webp="item.img_webp"
              :avif="item.img_avif"
              :alt="item.txt1"
              width="209"
              height="172"
            />
            <div class="other-bottom">
              <div class="number" :style="'color:' + color[index]">
                <span>{{ item.number }}</span
                ><span class="span" :style="'background-color:' + color[index]"></span>
              </div>
              <h4>{{ item.txt1 }}</h4>
              <!-- <div class="text2">{{item.text2}}</div> -->
            </div>
          </div>
        </div>
        <!-- <div class="app-button">Booking the service </div> -->
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
// import ManagementComponent from '@comps/ManagementComponent';
import CompHouseCard from '@/components/CompHouseCard.vue';
import * as icons from '@assets/images/icon';
import * as allIndex from '@assets/images/index';
import Cookies from 'js-cookie';

import { mapGetters } from 'vuex';
import prerenderMixin from '@/mixins/prerenderMixin';
import { isMobileDevice } from '@/plugins/deviceDetector';
import { buildDetailPath } from '@/utils/detailRoute';

export default {
  name: 'Index',
  mixins: [prerenderMixin],
  components: {
    CompHouseCard,
  },
  data() {
    return {
      banner: {
        jpg: '/img/banner.jpg',
        avif: '/img/banner.avif',
        webp: '/img/banner.webp',
        width: 1920,
        height: 1000,
      },
      bannerMobile: {
        jpg: '/img/banner-mobile.jpg',
        avif: '/img/banner-mobile.avif',
        webp: '/img/banner-mobile.webp',
        width: 603,
        height: 736,
      },
      search_icon: icons.searchIcon,
      row_down: icons.rowDown,
      row_up: icons.rowUp,
      input: '',
      tabActive: 1,
      cityIndex2: 0,
      indexPath: {
        name: 'index',
        id: 1,
      },
      color: ['#d7b893', '#bc829b', '#bac191', '#aa95c4'],
      search: {},
      rent: [],
      newHouse: [null, null, null],
      saleHouse: [null, null, null],
      managementList: [null, null, null],
      universityList: [],
      newHouseLoading: true,
      saleHouseLoading: true,
      managementLoading: true,
      other: [
        {
          txt1: 'MAINTENANCE SERVICES',
          img: allIndex.otherImg,
          img_webp: allIndex.otherImgWebp,
          img_avif: allIndex.otherImgAvif,
          number: '01',
        },
        {
          txt1: 'CLEANING SERVICES',
          img: allIndex.otherImg2,
          img_webp: allIndex.otherImg2Webp,
          img_avif: allIndex.otherImg2Avif,
          number: '02',
        },
        {
          txt1: 'MOVING SERVICES',
          img: allIndex.otherImg3,
          img_webp: allIndex.otherImg3Webp,
          img_avif: allIndex.otherImg3Avif,
          number: '03',
        },
        {
          txt1: 'PICK-UP/DROP-OFF SERVICES',
          img: allIndex.otherImg4,
          img_webp: allIndex.otherImg4Webp,
          img_avif: allIndex.otherImg4Avif,
          number: '04',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      setting: 'setting',
      price: 'optionPrice',
      typeList: 'optionTypeList',
    }),
    heroAvifSrcset() {
      return [
        '/img/banner-mobile-640.avif 640w',
        '/img/banner-mobile-960.avif 960w',
        '/img/banner-1280.avif 1280w',
        '/img/banner-1600.avif 1600w',
      ].join(', ');
    },
    heroWebpSrcset() {
      return [
        '/img/banner-mobile-640.webp 640w',
        '/img/banner-mobile-960.webp 960w',
        '/img/banner-1280.webp 1280w',
        '/img/banner-1600.webp 1600w',
      ].join(', ');
    },
  },
  created() {
    this.currentBanner = isMobileDevice() ? this.bannerMobile : this.banner;
    // note: 原本 LCP 3.73 - 查看初始化数据的时序影响 原本是 mounted -> 3.69
    // todo: 可以考虑静态缓存房源信息, 佟老师说基本不会更新
    this.initPageSEO();
    this.getNewHouse();
    this.getSaleHouse();
    this.getManagementHouse();
  },
  methods: {
    changeStage() {
      this.tabActive == 1 ? (this.tabActive = 2) : (this.tabActive = 1);
    },
    async getNewHouse() {
      try {
        const res = await this.axios.get(
          this.url + '/investment/properties/new_house_recommend',
          {},
        );
        this.newHouse = res.data.data;
        this.newHouseLoading = false;
      } catch (error) {
        console.error('Failed to load new houses:', error);
        this.newHouseLoading = false;
      }
    },
    getSaleHouse() {
      let _this = this;
      this.axios
        .get(this.url + '/investment/properties/sales_home_recommend', {})
        .then(function (res) {
          _this.saleHouse = res.data.data;
          _this.saleHouseLoading = false;
        })
        .catch(function () {
          _this.saleHouseLoading = false;
        });
    },
    getManagementHouse() {
      let _this = this;
      this.axios
        .get(this.url + '/investment/properties/property_index_t', {})
        .then(function (res) {
          console.log(res);
          _this.managementList = res.data.data;
          _this.managementLoading = false;
        })
        .catch(function () {
          _this.managementLoading = false;
        });
    },
    // getRent(){
    //   var that = this
    //   this.axios.get(this.url+'/lease/properties/torent',{}).then(function(res){
    //     for (const key in res.data.data) {
    //       that.rent.push({cityName:key,list:res.data.data[key]})
    //     }
    //     that.rentList = that.rent[0].list;
    //   }).catch(function() {
    //   });
    // },
    // switchTab2(index){
    //   this.cityIndex2 = index;
    //   this.rentList = this.rent[index].list;
    // },
    pushSearch() {
      this.$router.push({ path: '/sale?type=' + this.tabActive });
      Cookies.set('searchVal', JSON.stringify(this.search));
    },
    goHouseDetail(id, type) {
      this.$router.push({ path: buildDetailPath('/houseDetail', id, { type }) });
    },
    goManagementPage() {
      this.$router.push({ path: '/managementList' });
    },
    goSaleList(type) {
      this.$router.push({ path: '/sale?type=' + type });
    },
    goManagementDetail(id) {
      this.$router.push({ path: buildDetailPath('/managementDetail', id) });
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 50rem;
  overflow: hidden;
  position: relative;

  ::v-deep .img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.search {
  width: 28rem;
  height: auto;
  position: absolute;
  right: 18rem;
  top: 13rem;
  background-color: #ffffff;

  .tab {
    height: 3rem;
    width: 100%;
    display: flex;
    font-family: PuHuiTiRegular;
    color: #fff;
    cursor: pointer;
    margin-bottom: 2rem;
    border-top: 0.1rem solid var(--c-primary);
    background-color: var(--c-primary);

    .item {
      flex: 1;
      text-align: center;
      line-height: 3rem;
    }

    .tab-active {
      color: var(--c-text);
      background-color: #fff;
    }
  }

  .select-item {
    position: relative;

    ::v-deep .select-icon {
      position: absolute;
      top: 1.25rem;
      right: 1rem;
      width: 0.9rem;
      height: 0.55rem;
    }
  }

  .input-item {
    padding: 0 3rem;

    .input {
      position: relative;
    }
  }

  .button {
    width: 14.05rem;
    // height: 3.05rem;
    line-height: 1.05rem;
    margin: 1rem auto 2rem;
    font-size: 1.1rem;
    font-family: PuHuiTiRegular;
    display: block;
    color: #ffffff;
    background-color: var(--c-primary);
  }

  ::v-deep .search-icon {
    position: absolute;
    right: 4rem;
    top: 5.8rem;
    width: 1.2rem;
    height: 1.2rem;
  }
}

.title {
  margin: 5rem 0 1.4rem 0;
}

.city-list {
  display: flex;

  .city-name {
    width: 8.8rem;
    height: 2.5rem;
    text-align: center;
    border-radius: 0.3rem;
    border: solid 0.05rem #bac0cc;
    color: var(--c-grey);
    font: 0.9rem PuHuiTiRegular;
    line-height: 2.5rem;
    margin-right: 0.45rem;
    cursor: pointer;
  }

  .active-city {
    color: #0f1d3d;
    border: solid 0.05rem #0f1d3d;
  }
}

.city-item {
  display: flex;
  justify-content: space-between;
  margin: 3rem 0 4rem;

  .city-img {
    width: 19.4rem;
    height: 16.55rem;
    position: relative;
    border-radius: 0.5rem;
    overflow: hidden;

    .image {
      width: 19.4rem;
      height: 16.55rem;
    }

    .house-name {
      width: 100%;
      height: 3.3rem;
      color: #fff;
      font: 1rem PuHuiTiMedium;
      line-height: 3.3rem;
      border-radius: 0.5rem;
      text-align: center;
      background: rgba($color: #34415e, $alpha: 0.6);
      position: absolute;
      bottom: 0;
    }
  }
}

.name {
  position: relative;
  color: #0f1d3d;
  font-size: 1.4rem;
  display: inline-block;
  font-family: PuHuiTiMedium;
}

.name::after {
  width: 100%;
  height: 0.85rem;
  background-color: var(--c-secondary);
  content: '';
  position: absolute;
  bottom: 0.2rem;
  left: 0;
  z-index: -2;
}

main {
  .describe {
    display: flex;
    justify-content: space-between;
    padding-top: 2rem;
    align-items: center;

    .des-text {
      font-family: PuHuiTiLight;
      color: var(--c-grey);
      font-size: 1rem;
    }

    .des-more {
      font-family: PuHuiTiMedium;
      color: #0f1d3d;
      font-size: 0.9rem;
      cursor: pointer;
      transition: color 0.2s;

      .des-more::after {
        content: '';
        position: fixed;
        top: 15rem;
        left: 15rem;
        border-radius: 3.75rem;
        border: 1px solid red;
        height: 7.5rem;
        width: 7.5rem;
        background: orange;
      }
      &:hover {
        color: var(--c-primary);
      }
    }
  }

  .burling-box {
    display: flex;
    justify-content: space-between;

    .box {
      width: 19.4rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .kong {
      width: 19.4rem;
    }

    .item-name {
      font-family: PuHuiTiMedium;
      font-size: 1.1rem;
      color: #0f1d3d;
      padding: 0.6rem 0.6rem;
    }

    .item-bottom {
      display: flex;
      padding: 0 1.6rem 0 0.6rem;
      justify-content: space-between;
      color: var(--c-text);
      font-size: 0.8rem;
      font-family: PuHuiTiLight;
    }

    .icon {
      display: flex;
      align-items: center;

      ::v-deep img {
        margin-right: 0.4rem !important;
      }
    }
  }

  .new-house {
    // overflow: hidden;

    .house-img {
      width: 100%;
      border-radius: 0 !important;
      background-color: #eee;
    }

    .box {
      cursor: pointer;
      border-radius: 0.8rem;
      overflow: hidden !important;
      border: solid 0.05rem #e7e7e7;
    }

    .box:hover {
      border: solid 0.05rem var(--c-secondary);
      // transform: translateY(-0.5rem);
      transition:
        background-color 0.3s,
        transform 0.3s ease-in-out;

      .item-price {
        background: var(--c-secondary);
      }
    }

    .item-price {
      padding: 0 1rem;
      height: 2.5rem;
      display: flex;
      margin-top: 0.8rem;
      justify-content: space-between;
      align-items: center;
      background: #f8f8f6;
      transition: background 0.3s;

      .price {
        font-family: PuHuiTiMedium;
        font-size: 1.2rem;

        span {
          font-size: 0.6rem;
          font-family: PuHuiTiLight;
          margin-right: 0.3rem;
        }
      }
    }

    .room-num-item {
      display: flex;
      align-items: center;
      font-family: PuHuiTiLight;

      img {
        margin-right: 0.2rem;
      }
    }
  }

  ::v-deep .box-img {
    width: 19.4rem;
    height: 13.5rem;
    font-size: 0.6rem;
    border-radius: 0.5rem 0.5rem 0 0;
    transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  @keyframes h2move {
    0% {
      top: 10.4rem;
    }

    100% {
      top: 5rem;
    }
  }
}

.other-box {
  margin-top: 5rem;
  width: 100%;
  background-color: #f7fafd;
  position: relative;
  // z-index: -2;
  padding-bottom: 3rem;

  .other-item {
    display: flex;
    justify-content: space-between;

    .item {
      width: 13.15rem;
    }

    .other-item-img {
      width: 13.15rem;
      height: 10.75rem;
    }

    .number {
      font: 1.6rem PuHuiTiMedium;
      margin-bottom: 1.6rem;
      display: flex;
      align-items: baseline;

      .span {
        display: inline-block;
        width: 7rem;
        height: 0.05rem;
        margin-left: 1rem;
      }
    }

    h4 {
      font-weight: normal;
      color: var(--c-text);
      font-size: 1rem;
      line-height: 1.5rem;
      font-family: PuHuiTiMedium;
    }

    .text2 {
      font-family: PuHuiTiLight;
      color: var(--c-grey);
      line-height: 1.5rem;
      margin-top: 0.8rem;
    }
  }

  .other-bottom {
    height: 9.25rem;
    padding: 1.3rem 1.2rem;
    background: #fff;
  }
}

::v-deep .icon-local {
  width: 1.15rem;
  height: 1.2rem;
}
::v-deep .icon-house {
  width: 1.18rem;
  height: 1.1rem;
}
::v-deep .icon-bed {
  width: 1rem;
  height: 0.9rem;
}
::v-deep .icon-bath {
  width: 0.95rem;
  height: 0.9rem;
}

@media only screen and (max-width: 1024px) {
  // .banner{
  //   margin-top: 5rem;
  // }
  .search {
    position: absolute;
    right: 50%;
    top: 10rem;
    margin-right: -14rem;
  }

  .title {
    width: 96%;
    margin: 3.4rem auto 1rem;
  }

  .name {
    font-size: 1.6rem;
    position: relative;
  }

  .name::after {
    height: 0.5rem;
    content: '';
  }

  main {
    .describe {
      padding-top: 0.6rem;

      .des-text {
        font-size: 1rem;
      }
    }

    .burling-box {
      width: 96%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;

      .box {
        width: 48%;
        margin-bottom: 1.2rem;
      }
    }

    .city-item {
      display: flex;
      flex-wrap: wrap;
      margin: 1.2rem 0 2rem;

      .city-img {
        margin-top: 1.2rem;
        width: 48%;
        height: auto;

        .image {
          width: 100%;
          height: 12rem;
        }
      }
    }

    ::v-deep .box-img {
      width: 100%;
      height: 12rem;
      border-radius: 0.5rem 0.5rem 0 0;
    }

    .icon span {
      font-size: 0.6rem;
    }
  }

  .other-box .other-item {
    width: 90%;
    margin: 0 auto;
    display: block;

    .item {
      width: 100%;
      display: flex;
      background: #fff;
      margin-top: 2rem;
    }
  }
}
</style>
<style lang="scss">
.page-index {
  .el-image {
    display: block;
  }

  .el-input__inner {
    width: 22rem;
    height: 3rem;
    font-size: 1.1rem;
    font-family: PuHuiTiRegular;
    line-height: 3rem;
    margin-bottom: 1rem;
    border-radius: 0.5rem;
    background-color: #f2f5fa;
  }

  .el-input input::-webkit-input-placeholder {
    color: #8a95ad;
    font-family: PuHuiTiRegular;
    font-size: 1.1rem;
    line-height: 3rem;
  }

  .el-input input::-moz-input-placeholder {
    color: #8a95ad;
    font-family: PuHuiTiRegular;
    font-size: 1.1rem;
    line-height: 3rem;
  }

  .el-input input::-ms-input-placeholder {
    color: #8a95ad;
    font-family: PuHuiTiRegular;
    font-size: 1.1rem;
    line-height: 3rem;
  }

  .el-icon-arrow-up::before {
    content: none;
  }
}
</style>
